import styled from 'styled-components'

export const Container = styled.section`
  width: 100%;
  margin-top: 16px;
  .cp-inner-cotainer{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    padding: 20px 20px 4px;
    background-color: var(--prices-background);
  }
  .cp-title{
    color: var(--title-color);
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
  }
  .cp-content{
    width: 100%;
    margin-top: 12px;
    padding-bottom: 16px;
    overflow-x: auto;
    .cp-inner-content{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
  }
  .coin-card{
    width: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
    &__icon{
      width: 28px;
      height: 28px;
      border-radius: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      background-color: #fff;
      img{
        width: 28px;
        height: 28px;
      }
    }
    &__info{
      margin-left: 8px;
      small{
        font-weight: 700;
        font-size: 14px;
        line-height: 1.57;
      }
      .cc-info{
        display: flex;
        justify-content: center;
        align-items: center;
        small{
          font-weight: 500;
        }
        .price-diff{
          display: flex;
          justify-content: center;
          align-items: center;
          height: 20px;
          padding: 0 6px;
          border-radius: 10px;
          margin-left: 8px;
          .MuiSvgIcon-root {
            margin: 0 -2px 0 -6px;
            fill: currentColor;
            width: 1em;
            height: 1em;
            display: inline-block;
            font-size: 1.5rem;
            transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
            flex-shrink: 0;
            user-select: none;
          }
          span{
            font-size: 12px;
            line-height: 1.33;
            padding-top: 2px;
          }
        }
      }
    }
  }
  .price-up{
    color: var(--price-up);
    background-color: var(--price-up-background);
  }
  .price-down{
    color: var(--price-down);
    background-color: var(--price-down-background);
  }


  @media screen and (max-width: 599px){
    .cp-inner-cotainer{
        align-items: center;
    }
    .coin-card{
      width: 180px;
      justify-content: flex-start;
    }
  }
`
